import * as M from 'materialize-css';
import Vue from 'vue';
import '../scss/styles.scss';
import ShoppingListRetailer from '../models/ShoppingListRetailers';
import { RecipeCarouselItem } from '../models/RecipeCarousel';

export default Vue.extend({
    name: 'RecipeCarousel',
    props: {
        creativeConfig: {
            type: Object as any,
            required: false,
        },
        recipeCarousel: {
            type: Array as () => RecipeCarouselItem[],
            required: true,
        },
        indicators: {
            type: Boolean,
            required: false,
            default: false,
        },
        dist: {
            type: Number,
            required: true,
            default: 0,
        },
        padding: {
            type: Number,
            required: true,
            default: -125,
        },
        numVisible: {
            type: Number,
            required: true,
            default: 10,
        },
        duration: {
            type: Number,
            required: false,
            default: 500,
        },
        address: {
            type: Object as () => ShoppingListRetailer,
            required: false,
        },
        isDefault: {
            type: Boolean,
            required: true,
        },
        logo: {
            type: String,
            required: false,
        },
        sponsor: {
            type: String,
            required: false,
        },
        headline: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        backgroundImageVisible: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            currentHeadlineIndex: (this.recipeCarousel.length) ? 0 : 1,
            carousel: HTMLElement,
            mCarousel: null as any | null,
            currentContent: '',
            currentContentIndex: -1,
            adArray: [],
        };
    },
    mounted() {
        this.start();
        this.updateCarousel();
    },
    methods: {
        updateCarousel() {
            if (this.mCarousel) {
                this.mCarousel.destroy();
            }
            const elem: Element = document.querySelector('.carousel') || this.$refs['carousel'] as Element;
            M.Carousel.init(elem, {
                indicators: this.indicators,
                dist: this.dist,
                padding: this.padding,
                numVisible: this.numVisible,
            });
            this.mCarousel = M.Carousel.getInstance(elem);
            const self = this;
            self.mCarousel.set(1);
            setTimeout(() => {
                self.mCarousel.next(3);
                setTimeout(() => self.mCarousel.prev(3), 1500);
            }, 1000);
        },
        start() {
            const vm = this;
            setInterval(() => {
                if (!vm.recipeCarousel.length) {
                    return;
                }
                vm.currentHeadlineIndex += 1;
                if (vm.currentHeadlineIndex >= vm.description.length) {
                    vm.currentHeadlineIndex = 0;
                }
            }, 4000);
        },
        buttonClicked() {
            this.$emit('actionBtnClicked');
        },
        updated() {
            this.updateCarousel();
            this.$forceUpdate();
        },
    },
    computed: {
        buttonText(): String {
            if (this.title === 'SummerGuard Cart' || this.backgroundImageVisible) {
                return 'Order Now!';
            }
            return 'Add to Cart';
        },
        description(): String[] {
            const descript = [];
            const regex = '{KROGER_CHAIN}';
            let zim = '';
            if (this.recipeCarousel.length && this.address.Chain) {
                for (let i = 0; i < this.recipeCarousel[0].Description.length; i++) {
                    zim = this.recipeCarousel[0].Description[i].replace(regex, this.address.Chain);
                    descript.push(zim);
                }
                return descript;
            } if (this.recipeCarousel.length && !this.address.Chain) {
                for (let i = 0; i < this.recipeCarousel[0].Description.length; i++) {
                    zim = this.recipeCarousel[0].Description[i].replace(regex, this.sponsor.charAt(0).toUpperCase() + this.sponsor.slice(1));
                    descript.push(zim);
                }
                return descript;
            }
            return this.recipeCarousel[0].Description;
        },
        chainLogo(): String {
            if (!this.address.Logo && this.sponsor === 'kroger') {
                return 'https://cdn.polaris.me/cva/img/kroger-square-logo.png';
            } if (!this.address.Logo && this.sponsor === 'walmart') {
                return 'https://cdn.polaris.me/cva/img/Walmart_Logos_TheSpark_ylw_rgb.png';
            }
            return this.address.Logo;
        },
    },
});
